import type { AreaRoutes } from "@/app/routes/hr/areaRoutes";
import { RequireCapability } from "@/app/session/RequireCapability";

/* Payroll: months, payslips, entries, advances, expense claims, pay and final settlements.
   Every page answers 404 while payroll is switched off; the months and a person's pay also
   without payroll.view, as the server does. One's own payslips and claims need neither. */
export const payrollRoutes: AreaRoutes = {
  people: [],
  employee: [
    {
      element: <RequireCapability feature="payroll" permission="payroll.view" />,
      children: [
        {
          path: "pay",
          lazy: async () => ({
            Component: (await import("@/features/payroll/routes/EmployeePayTab")).default,
          }),
        },
      ],
    },
  ],
  me: [
    {
      element: <RequireCapability feature="payroll" />,
      children: [
        {
          path: "pay",
          lazy: async () => ({
            Component: (await import("@/features/payroll/routes/MyPayTab")).default,
          }),
        },
        {
          path: "pay/:month",
          lazy: async () => ({
            Component: (await import("@/features/payroll/routes/MyPayslipPage")).default,
          }),
        },
      ],
    },
  ],
  top: [
    {
      element: <RequireCapability feature="payroll" permission="payroll.view" />,
      children: [
        {
          path: "payroll",
          lazy: async () => ({
            Component: (await import("@/features/payroll/routes/PayrollIndex")).default,
          }),
        },
        {
          path: "payroll/:month",
          lazy: async () => ({
            Component: (await import("@/features/payroll/routes/PayrollMonthLayout")).default,
          }),
          children: [
            {
              index: true,
              lazy: async () => ({
                Component: (await import("@/features/payroll/routes/PayrollSheetPage")).default,
              }),
            },
            {
              path: "summary",
              lazy: async () => ({
                Component: (await import("@/features/payroll/routes/PayrollSummaryPage")).default,
              }),
            },
            {
              path: "entries",
              lazy: async () => ({
                Component: (await import("@/features/payroll/routes/PayrollEntriesPage")).default,
              }),
            },
            {
              path: "advances",
              lazy: async () => ({
                Component: (await import("@/features/payroll/routes/PayrollAdvancesPage")).default,
              }),
            },
            {
              path: "claims",
              lazy: async () => ({
                Component: (await import("@/features/payroll/routes/PayrollClaimsPage")).default,
              }),
            },
          ],
        },
      ],
    },
  ],
};
